<template>
  <el-popover
    width="100"
    popper-class="sheet-menu-popper"
    trigger="click"
    style="min-width: unset"
    :placement="placement"
  >
    <div
      v-for="(item, index) in menuList"
      :key="index"
      @click="changeData(item)"
      class="menu"
      :class="{ active: curName === item.name }"
      v-tip
    >
      {{ item.name }}
    </div>
    <div slot="reference">
      <i class="el-icon-arrow-down"></i>
    </div>
  </el-popover>
</template>
<script>
export default {
  name: "sheet-menu-popper",
  props: {
    menuList: Array,
    curName: String,
    placement: {
      type: String,
      default: "bottom"
    }
  },
  data() {
    return {}
  },
  methods: {
    changeData(item) {
      this.$emit("update:curName", item.name)
      this.$emit("changeData", item)
    }
  }
}
</script>

<style lang="scss">
.sheet-menu-popper {
  min-width: unset !important;
  padding: 10px 20px 0 20px !important;
  .menu {
    cursor: pointer;
    margin-bottom: 10px;
    &.active {
      color: #1989fa;
    }
  }
}
</style>
